<a
  #linkEl
  [href]="field.templateOptions?.url"
  target="_blank"
  >{{field.templateOptions?.txt|translate}}</a
>
